import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingRecord } from 'components/dynamic/dynamic-page/dynamic-page-record-leave-entitlement/DynamicPageRecordLeaveEntitlementSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
  unid: null,
  progressing: false,
  startDate: '',
  endDate: '',
};

const employeeLeaveEntitlementRecordFormSlice = createSlice({
  name: 'employeeLeaveEntitlementRecordForm',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setUpdateLineRecord(state, action) {
      const { record, subRecord, keyTableLine, lineUnid } = action.payload;
      const resRecord = record;
      const fieldNames = Object.keys(resRecord);
      const tmpRecord = { ...state.record };

      fieldNames.forEach((fieldName) => {
        tmpRecord[fieldName] = resRecord[fieldName];
      });

      const index = tmpRecord[keyTableLine].findIndex((element) => element.id.toString() === lineUnid.toString());
      if (index !== -1) {
        tmpRecord[keyTableLine][index] = subRecord;
        state.record = tmpRecord;
      }
    },
  },
});

const { setPageInfo, setFormLoading } = employeeLeaveEntitlementRecordFormSlice.actions;

export const { setRecord, setUnid, setStartDate, setEndDate } = employeeLeaveEntitlementRecordFormSlice.actions;

export const initPageInfo =
  ({ informationPage, viewingRecord, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));

      let url = `${informationPage.url}/index-info?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: viewingRecord.unid,
        leave_type: viewingRecord.leaveType,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
            if (!document.status) {
              dispatch(setViewingRecord(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

// export const searchingDate =
//   ({ viewingRecord, startingDate, endingDate }) =>
//   async (dispatch) => {
//     try {
//       dispatch(setFormLoading(true));

//       let url = `/employee-leave-entitlement-record/index-info?`;
//       url += `auth_token=${Service.userToken}`;

//       const data = JSON.stringify({
//         data_unid: viewingRecord.unid,
//         leave_type: viewingRecord.leaveType,
//         starting_date: startingDate,
//         ending_date: endingDate,
//       });

//       RequestApi(url, {
//         data,
//       })
//         .then((res) => {
//           if (res.data.status === 'success') {
//             dispatch(setRecord(res.data.record));

//             if (!document.status) {
//               dispatch(setViewingRecord(res.data.record));
//             }
//           } else {
//             NotificationMessage({ message: res.data.msg, status: res.data.status });
//           }

//           dispatch(setFormLoading(false));
//         })
//         .catch((err) => {
//           console.log(err);
//           dispatch(setFormLoading(false));
//           NotificationMessage({ message: err.toString(), status: 'error' });
//         });
//     } catch (ex) {
//       dispatch(setFormLoading(false));
//       NotificationMessage({ message: ex.toString(), status: 'error' });
//     }
//   };

const employeeLeaveEntitlementRecordFormReducer = employeeLeaveEntitlementRecordFormSlice.reducer;

export default employeeLeaveEntitlementRecordFormReducer;
